import PointAndClick from './PointAndClick.js';
import Phaser from 'phaser';

import Ordi from '../../prefabs/chapitre4/ordi/Ordi.js';
import { Colors } from '../../consts/Colors.js';
import FONTS from '../../consts/Fonts.js';
import ButtonRounded from '../../prefabs/global/buttons/ButtonRounded.js';
import PopUpBlue from '../../prefabs/global/popup/PopUpBlue.js';
import QuestionPanel_1 from '../../prefabs/chapitre4/questions/QuestionPanel_01.js';
import QuestionPanel_2 from '../../prefabs/chapitre4/questions/QuestionPanel_02.js';
import QuestionPanel_3 from '../../prefabs/chapitre4/questions/QuestionPanel_03.js';
import DebriefPanel from '../../prefabs/chapitre4/DebriefPanel.js';


export default class Chapitre4 extends PointAndClick {
    constructor() {
        super({
            key: "Chapitre4"
        })
    }

    init(data){
        this.audioName = 'UnderTheRadar';
        super.init(data);   

        this.light = null
        this.gameStrarted = false
    }

    create(){
        super.create();

        // Ajout spot light
        this.cover = this.add.image(0, 0, this.scene.key + '_background_cover').setOrigin(0, 0);
        this.cover.depth = -1
        this.light = this.make.image({
            x: -400,
            y: -400,
            key: 'mask_lumiere',
            add: false 
        });

        this.background.mask = new Phaser.Display.Masks.BitmapMask(this, this.light);
        this.input.on(Phaser.Input.Events.POINTER_MOVE, this.handlePointerMove, this)

        // Ajout popup d'intro
        this.popupIntro = new PopUpBlue(this, this.width/2, this.height/2, 660, 420)
        this.popupIntro.setAlpha(0);


        let introText = "Le bureau du responsable du marketing. Les réponses à mes questions doivent s’y trouver : pourquoi Leïla fait-elle la promotion de produits douteux ? Où se trouve-t-elle ?\n\nJe vais devoir faire preuve de discretion pour ne pas attirer l’attention des vigiles. ";
        let popupIntroText = this.add.text(0, 0, introText, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '24px',
            color: Colors.Text.White,
            lineSpacing: 8,
            align: 'left',
            wordWrap: { width: 550 }
        }).setOrigin(0.5, 0);
        this.popupIntro.addElementToBody(popupIntroText, 40);

        let buttonCloseIntro = new ButtonRounded(this, 0, 0,  { 
            text: "Fouiller la pièce",
            color: Colors.Elmt.White,
            textColor: Colors.Text.Black,
            textHoverColor: Colors.Text.Blue,
            borderColor: Colors.Elmt.White,
            borderHoverColor: Colors.Elmt.Blue,
        });
        this.popupIntro.addButtonToBody(buttonCloseIntro);
        buttonCloseIntro.setClickFunction( () => {
           this.popupIntro.animOut(() => {
                this.popupIntro.destroy(true);
                this.gameStrarted = true;
            });
        })

        this.popupIntro.animIn()
        this.buttons.forEach(button => {
            button.viewed = false
            button.setAlpha(0)
        })
    }

    update(){
        if(this.ordi)
            this.ordi.update();
    }

    handlePointerMove(pointer)
	{
        if(!this.gameStrarted)
            return;

		this.light.x = pointer.x;
        this.light.y = pointer.y;

        this.buttons.forEach(button => {
            if(Phaser.Math.Distance.Between(button.x, button.y, pointer.x, pointer.y) < 130){
                if(!button.viewed){
                    button.viewed = true
                    button.alpha = 0
                    this.tweens.add({
                        targets: button,
                        alpha: 1,
                        scale: 1,
                        duration: 300,
                    })
                }
            }else{
                if(button.viewed){
                    button.viewed = false
                    this.tweens.add({
                        targets: button,
                        alpha: 0,
                        scale: 0.8,
                        duration: 300,
                    })
                }
            }
        })
	}

    showButtons(){
        // on ne fait rien ici et on vient réécrire la fonction de la class qu'on étend
    }

    openIndice(id){
        super.openIndice(id);
        this.popup.closeButton.y+=10
        this.gameStrarted = false
    }

    closePopup(){
        super.closePopup();
        this.gameStrarted = true
    }

    // -- Popups spécifiques --
    openIndiceSpecial(id, data){
        if(data.type == "ordinateur"){
            this.openOrdinateur(id, data);
        }
        else if(data.type === "vue"){
            this.openVue(id, data);
        }
         else if(data.type === "presentoir"){
            this.openPresentoir(id, data);
        }
    }

    openVue(id, data){
        this.openIndice(id);
        this.popup.textElmt.setStyle({
            align: 'left',
        })
    }

    openPresentoir(id, data){
        this.openIndice(id);
        this.popup.textElmt.setStyle({
            align: 'left',
        })
    }

    openOrdinateur(id, data){
        if(this.ordi)
            return

        this.gameStrarted = false

        this.blurBackground();

        // Close ordi si on clique en dehors
        this.background.setInteractive()
        this.background.on('pointerup', () => {
            this.closePopup();
            if(this.ordiPopup)
                this.ordiPopup.animOut(() => {
                    this.ordiPopup.destroy(true);
                    this.ordiPopup = null;
                });
            this.background.disableInteractive();
            this.background.removeListener('pointerup');
        })

        // Ajout ordinateur
        this.ordi = new Ordi(this, this.width/2, this.height)
        this.ordi.setAlpha(0)
        this.ordi.y = this.height - this.ordi.height + 50

        this.ordi.animIn(() => {
            // Change la musique
            this.soundManager.playAudio('DangerAhead')

            // Affiche l'ordi bloqué si besoin
            if(this.ordi.isLocked()){
                this.popupMDP();
            }else{
                // Affiche le panneau de question si l'ordi est débloqué
                this.addQuestionPanel();
            }
        })
    }

    // Popup à l'ouverture de l'ordi quand il est bloqué
    popupMDP(){
        this.ordiPopup = new PopUpBlue(this, this.width/2, 950, 700, 200)

        let text = "Il faut trouver un moyen de déverrouiller l'ordinateur."
        let textElmt = this.add.text(0, 0, text, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '24px',
            color: Colors.Text.White,
            align: 'center',
        }).setOrigin(0.5, 0);
        this.ordiPopup.addElementToBody(textElmt, 40)

        let buttonNext = new ButtonRounded(this, 0, 0, {
            text: "Continuer de fouiller la pièce",
            color: Colors.Elmt.DarkBlue,
            hoverColor: Colors.Elmt.White,
            textColor: Colors.Text.White,
            textHoverColor: Colors.Text.DarkBlue,
            borderColor: Colors.Elmt.White,
        })
        this.ordiPopup.addButtonToBody(buttonNext)


        this.ordiPopup.animIn()

        buttonNext.setClickFunction( () => {
            this.ordiPopup.animOut(() => {
                this.ordiPopup.destroy(true);
                this.closePopup();
            })
        })

    }


    // Popup au débloquage de l'ordi, permet de débuter l'enquete ou de retourner à la pièce
    popupStart(){
        // MAJ progression
        this.chapitreProgression.ordi.locked = false;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);

        this.ordiPopup = new PopUpBlue(this, 730, this.height/2, 600, 350)
        
        let textElmt = this.add.text(0, 0, "Encore cette publicité avec le temple…\n\nMais l’image semble étrange. Je devrais vérifier ça avant de filer à Genève voir la conférence de Leïla.", {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '24px',
            color: Colors.Text.White,
            align: 'center',
            lineSpacing: 8,
            wordWrap: { width: 500 }, 
        }).setOrigin(0.5,0);
        this.ordiPopup.addElementToBody(textElmt, 40)

        let buttonStart = new ButtonRounded(this, 0, 0, {
            text: "Démarrer l'enquête",
            color: Colors.Elmt.White,
            textColor: Colors.Text.DarkBlue,
            hoverColor: Colors.Elmt.DarkBlue,
            textHoverColor: Colors.Text.White,
            borderColor: Colors.Elmt.White,
        })
        buttonStart.setClickFunction( () => {
            this.ordiPopup.animOut(() => {
                this.ordiPopup.destroy(true);
                this.ordi.unlockButtons()
                this.addQuestionPanel1();
            })
        })
        this.ordiPopup.addButtonToBody(buttonStart)

        this.ordiPopup.animIn()
    }

    // Appelé par l'ordi quand le code est rentré correctement
    closePopupOrdi(endFunc){
        if(this.ordiPopup == null || this.ordiPopup == undefined) return;

        this.ordiPopup.animOut(() => {
            this.ordiPopup.destroy(true);
            this.ordiPopup = null;
            if(endFunc)
                endFunc();
        })
    }

    addQuestionPanel(){
        const num = this.chapitreProgression.ordi.question
        switch(num){
            case 1:
                this.addQuestionPanel1()
                break;
            case 2:
                this.addQuestionPanel2()
                break;
            case 3:
                this.addQuestionPanel3()
                break;
        }
    }

    // Panneau de question qui s'ouvre une fois l'enquete débutée
    addQuestionPanel1(){
        this.chapitreProgression.ordi.question = 1;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
        this.questionPanel = new QuestionPanel_1(this, 0, 0, {config: this.config.questions[0], totQuestion: this.config.questions.length})
        this.questionPanel.depth = 999
        this.questionPanel.animIn();
    }

    addQuestionPanel2(){
        this.chapitreProgression.ordi.question = 2;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
        this.questionPanel = new QuestionPanel_2(this, 0, 0, {config: this.config.questions[1], totQuestion: this.config.questions.length})
        this.questionPanel.depth = 999
        this.questionPanel.animIn();
    }

    addQuestionPanel3(){
        this.chapitreProgression.ordi.question = 3;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
        this.questionPanel = new QuestionPanel_3(this, 0, 0, {config: this.config.questions[2], totQuestion: this.config.questions.length})
        this.questionPanel.depth = 999
        this.questionPanel.animIn();
    }

    addDebrief(){
        this.debrief = new DebriefPanel(this)
        this.debrief.depth = 100
        this.debrief.animIn();
    }

    closeDebrief(){
        this.debrief.destroy(true);

        this.closePopup()
        this.gameStrarted = false;
        this.time.addEvent({
            delay: 500,
            callback: () => {
                this.gameStrarted = false;
                let txt = 'Tout n’est que tromperie et manipulation dans cette entreprise : publicités truquées, vertus botaniques inventées, laboratoires fictifs…\n\nQuel est le rôle de Leïla dans cette vaste escroquerie ?\n\nDirection Genève pour obtenir des explications !'
                this.popupFinChapitre(txt, 480, "DebutChapitre5");
            }
        })
    }

    closePanelQuestion(endFunc){
        if(this.questionPanel == null || this.questionPanel == undefined) return;

        // Ferme le panneau de question
        this.questionPanel.animOut(() => {
            this.questionPanel.destroy(true);
            this.questionPanel = null;

            if(endFunc)
                endFunc(this);
        })
    }

}